export const PENDING_RECEIPT = "Pending Receipt";
export const DIAGNOSTICS_PERFORMED = "Diagnostics Performed";
export const QUARANTINE_HOLD = "Quarantine Hold";
export const DEVICE_CONVERSION = "Device Conversion";
export const CHARGING_STAGING = "Charging Staging";
export const CHARGING = "Charging";
export const CONVERSION_STAGING = "Converting Staging";
export const RECEIVING_IN_PROGRESS = "Receiving in Progress";
export const PHYSICAL_DAMAGE = "Physical Damage/LCD";
export const SCREEN_BURN = "Screen Burn/Small Chip";
export const RETURN_TO_CUSTOMER = "Returned to Customer";
export const LOST_IN_TRANSIT = "Lost In Transit";
export const SENT_BACK_TO_PARTNER = "Sent Back To Partner";
export const NOT_DEVLIVERED = "Not Delivered";
export const TRADE_IN_COMPLETED = "Trade-In Process Complete";
export const VALUATION_COMPLETED = "Valuation Completed";
export const DEVICE_RECEIVED = "Device Received";
